import {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {apiPost, login, logout} from "../utils";
import {Button, IconButton, InputAdornment, TextField, Typography} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {Visibility, VisibilityOff} from "@mui/icons-material";

export const LoginContainer = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    const navigate = useNavigate();

    useEffect(() => {
        logout();
    }, []);

    const onEmailChange = (event) => {
        setErrorMessage(null);
        setEmail(event.target.value);
    };

    const onPasswordChange = (event) => {
        setErrorMessage(null);
        setPassword(event.target.value);
    };

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const onSubmit = () => {
        if (!!email && !!password) {
            setErrorMessage(null);
            const loginPostBody = {
                email: email,
                password: password
            }
            apiPost(`auth/login`, loginPostBody, (data) => {
                if (data.success) {
                    login(data);
                    navigate('/dashboard');
                } else {
                    setErrorMessage('Login failed');
                }
            });
        } else {
            setErrorMessage('Please enter email and password');
        }
    };

    return (
        <Grid container justifyContent="center" style={{marginTop: 100}}>
            <Grid container justifyContent="center" style={{width: 400}}>
                <Grid size={12}>
                    <TextField id="emailField" label="Email" value={email} style={{width: 400}}
                               type="email" required autoFocus
                               onChange={onEmailChange}
                               onKeyDown={e => {if (e.key === 'Enter') onSubmit()}}/>
                </Grid>
                <Grid size={12} style={{marginTop: 15}}>
                    <TextField id="passwordField" label="Password" value={password} style={{width: 400}}
                               type={showPassword ? 'text' : 'password'} required
                               onChange={onPasswordChange}
                               onKeyDown={e => {if (e.key === 'Enter') onSubmit()}}
                               InputProps={{
                                   endAdornment: (
                                       <InputAdornment>
                                           <IconButton onClick={handleShowPassword}>
                                               {showPassword ? <VisibilityOff/> : <Visibility/>}
                                           </IconButton>
                                       </InputAdornment>
                                   )
                               }}/>
                </Grid>
                <Grid size={8} style={{paddingTop: 30}}>
                    <Typography variant="h7" color="red" style={{marginLeft: 15}}>
                        {errorMessage}
                    </Typography>
                </Grid>
                <Grid size={4} style={{paddingTop: 30, textAlign: "right"}}>
                    <Button variant="outlined" type="submit" color="primary" onClick={onSubmit}>Submit</Button>
                </Grid>
            </Grid>
        </Grid>
    );
}